import DOMPurify from 'dompurify'

const allowedHref = /^(?:(?:https|mailto|tel):|\/(?!\/)|#)/i

type SanitizeHtmlOptions = {
  openLinksInNewTab?: boolean
}

DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.nodeName !== 'A') return
  const el = node as Element

  const href = (el.getAttribute('href') || '').trim()
  if (!href || !allowedHref.test(href)) {
    el.removeAttribute('href')
  }

  const target = el.getAttribute('target')
  if (target) {
    if (target === '_blank') {
      el.setAttribute('rel', 'noopener noreferrer')
    } else {
      el.removeAttribute('target')
      el.removeAttribute('rel')
    }
  } else {
    el.removeAttribute('rel')
  }
})

function setLinksToOpenInNewTab(html: string): string {
  if (typeof document === 'undefined') return html

  const template = document.createElement('template')
  template.innerHTML = html

  template.content.querySelectorAll<HTMLAnchorElement>('a[href]').forEach(anchor => {
    anchor.setAttribute('target', '_blank')
    anchor.setAttribute('rel', 'noopener noreferrer')
  })

  return template.innerHTML
}

export function sanitizeHtml(html: unknown, options: SanitizeHtmlOptions = {}): string {
  const sanitized = DOMPurify.sanitize(String(html ?? ''), {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel'],
  })

  return options.openLinksInNewTab ? setLinksToOpenInNewTab(sanitized) : sanitized
}

export function useSanitizeHtml() {
  return { sanitizeHtml }
}
